import React from 'react';
import { Brain, Dumbbell } from 'lucide-react';
import { useProfileStore } from '../../store/profileStore';
import { useNavigate } from 'react-router-dom';

export function ProfileModeToggles() {
  const { isNerdMode, isTrainerMode, toggleNerdMode, toggleTrainerMode } = useProfileStore();
  const navigate = useNavigate();

  const handleTrainerModeToggle = () => {
    toggleTrainerMode();
    // Navigate to appropriate route after toggle
    if (!isTrainerMode) {
      navigate('/trainer');
    } else {
      navigate('/home');
    }
  };

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">App Mode</label>
      
      {/* Nerd Mode Toggle */}
      <button
        onClick={toggleNerdMode}
        className={`w-full p-3 rounded-lg flex items-center justify-between transition-colors ${
          isNerdMode
            ? 'bg-gradient-to-br from-primary/20 to-purple-500/20 text-primary'
            : 'bg-muted text-muted-foreground hover:bg-muted/70'
        }`}
      >
        <div className="flex items-center gap-2">
          <div className="relative">
            <Brain className="w-4 h-4" />
            {isNerdMode && (
              <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
            )}
          </div>
          <span>Fitness Nerd Mode</span>
        </div>
        <div className={`w-11 h-6 rounded-full transition-colors relative ${
          isNerdMode ? 'bg-primary' : 'bg-muted-foreground/20'
        }`}>
          <div className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-transform ${
            isNerdMode ? 'right-1' : 'left-1'
          }`} />
        </div>
      </button>

      {/* Trainer Mode Toggle */}
      <button
        onClick={handleTrainerModeToggle}
        className={`w-full p-3 rounded-lg flex items-center justify-between transition-colors ${
          isTrainerMode
            ? 'bg-gradient-to-br from-primary/20 to-purple-500/20 text-primary'
            : 'bg-muted text-muted-foreground hover:bg-muted/70'
        }`}
      >
        <div className="flex items-center gap-2">
          <div className="relative">
            <Dumbbell className="w-4 h-4" />
            {isTrainerMode && (
              <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
            )}
          </div>
          <span>Trainer Mode</span>
        </div>
        <div className={`w-11 h-6 rounded-full transition-colors relative ${
          isTrainerMode ? 'bg-primary' : 'bg-muted-foreground/20'
        }`}>
          <div className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-transform ${
            isTrainerMode ? 'right-1' : 'left-1'
          }`} />
        </div>
      </button>
    </div>
  );
}